module.exports = __webpack_public_path__ + "img/Oluma.00ab7154.jpg";